import { render } from "./GroupListItem.vue?vue&type=template&id=9dc65954&scoped=true&ts=true"
import script from "./GroupListItem.vue?vue&type=script&lang=ts"
export * from "./GroupListItem.vue?vue&type=script&lang=ts"

import "./GroupListItem.vue?vue&type=style&index=0&id=9dc65954&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dc65954"]])

export default __exports__